import PropTypes from 'prop-types';
import React from 'react';

import PressHero from '../image-hero/image-hero';
import PressInquiries from './press-inquiries/press-inquiries';
import PressStroke from '../company-stroke/company-stroke';
import PressHeader from '../company/company-header/company-header';
import PressArchive from './press-archive/press-archive';
import PressCategory from './press-category/press-category';

import { ARTICLE_TYPE } from './press-article/press-article';

const blogArticles = [
  {
    title: 'The latest from HQ',
    excerpt:
      'Check out our blog for the latest company updates and announcements.',
    type: ARTICLE_TYPE.PAGE_PREVIEW,
    className: 'hq',
    previewLinkText: 'See more',
    link: 'https://www.nerdwallet.com/blog/category/corporate-news/',
  },
];

const extraPages = [
  {
    title: 'Meet our specialists',
    excerpt: 'Get to know our thought leaders and experienced specialists.',
    type: ARTICLE_TYPE.PAGE_PREVIEW,
    className: 'experts',
    previewLinkText: 'See more',
    link: '/specialists',
  },
];

const PressPage = ({ pressArticles }) => (
  <div className="press-page">
    <PressHero
      backgroundClassName="press-page-hero"
      preheader="Press"
      title="The press room"
      body="It's all here. Company info, recent press releases, NerdWallet in the news and must-read studies from our pros."
      bodyMobile="It's all here. Company info, recent press releases, NerdWallet in the news and must-read studies from our pros."
      opacityLevel={0.7}
    />
    <PressInquiries />
    <PressStroke />
    <PressHeader headerText="Making Headlines" />
    <PressArchive link="/news" articles={pressArticles.headlines.featured} />
    <PressStroke />
    <PressCategory articles={blogArticles} />
    <PressStroke />
    <PressCategory articles={extraPages} />
  </div>
);

PressPage.displayName = 'PressPage';

PressPage.propTypes = {
  pressArticles: PropTypes.object.isRequired,
};

export default PressPage;
